import React, { createContext, useContext, useEffect, useState } from 'react';
import api, { setToken, clearToken, getToken } from '@/lib/adminApi';

const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(undefined); // undefined = checking

  useEffect(() => {
    if (!getToken()) {
      setAdmin(null);
      return;
    }
    api.get('/auth/me')
      .then((res) => setAdmin(res.data))
      .catch(() => { clearToken(); setAdmin(null); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    setToken(data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch { /* ignore */ }
    clearToken();
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
